<template>
  <div class="main">
    <div class="model-main">
      <div class="close">
        <img
          src="https://img.yilieyun.com/ats-speed-version/statistics/yly/icon_computer%402x.png"
          style="
            cursor: pointer;
            height: 40px;
            transform: scale(1.5);
            position: relative;
            top: 10px;
            left: 12px;
          "
          v-if="codeType == 2"
          @click="
            () => {
              codeType = 1;
              tagActive = 1;
            }
          "
        />
        <img
          src="https://img.yilieyun.com/ats-speed-version/statistics/yly/icon_RQ%20code%402x.png"
          style="
            cursor: pointer;
            height: 40px;
            transform: scale(1.5);
            position: relative;
            top: 10px;
            left: 12px;
          "
          v-if="codeType == 1"
          @click="
            () => {
              codeType = 2;
            }
          "
        />
        <img
          style="width: 30px; height: 31px; margin: 0 10px 0 0; cursor: pointer"
          @click="close()"
          src="https://img.yilieyun.com/ats-speed-version/statistics/icon_Close-2%402x.png"
        />
      </div>
      <!-- '密码登录' : '验证码登录 -->
      <div class="form-wrap" v-if="codeType == 1">
        <div class="form">
          <!-- <p class="title">{{ tagActive == 1 ? '密码登录' : '验证码登录' }}</p> -->
          <p
            class="title"
            style="
              padding: 32px 32px;
              display: flex;
              justify-content: space-between;
              color: #979aad;
            "
          >
            <span
              :style="{ color: tagActive == 1 ? '#333333' : '#979aad' }"
              style="cursor: pointer; font-size: 24px"
              @click="
                () => {
                  tagActive = 3 - tagActive;
                  unRegisteredType = false;
                }
              "
              >密码登录</span
            >
            <span
              :style="{ color: tagActive != 1 ? '#333333' : '#979aad' }"
              style="cursor: pointer; font-size: 24px"
              @click="
                () => {
                  tagActive = 3 - tagActive;
                  unRegisteredType = false;
                }
              "
              >验证码登录</span
            >
          </p>
          <div class="content">
            <el-form>
              <el-form-item>
                <el-input
                  v-model="mobile"
                  placeholder="请输入手机号"
                  @focus="
                    () => {
                      unRegisteredType = false;
                      have_mobile = false;
                    }
                  "
                  @keyup.native.enter="submitForm()"
                />
                <span class="tips_red" v-show="have_mobile">{{have_mobile_text}}</span>
              </el-form-item>
              <el-form-item v-if="tagActive == 1">
                <el-input
                  v-model="password"
                  :type="eyeType ? 'password' : ''"
                  placeholder="请输入密码"
                  @focus="getfocusPassword()"
                  @keyup.native.enter="submitForm()"

                />
                <span class="tips_red" v-show="have_password">请输入密码</span>
                <div
                  class="eye"
                  @click="
                    () => {
                      eyeType = !eyeType;
                    }
                  "
                >
                  <img
                    v-if="eyeType"
                    src="https://img.yilieyun.com/ats-speed-version/statistics/eye/hide.png"
                  />
                  <img
                    v-if="!eyeType"
                    src="https://img.yilieyun.com/ats-speed-version/statistics/eye/show.png"
                  />
                </div>
                <!-- show-password -->
              </el-form-item>
              <el-form-item class="verifiCation" v-if="tagActive == 2">
                <el-input v-model="setMessagCode"   @focus="getfocustagActive()" placeholder="请输入验证码" />
                <span class="tips_red" v-show="have_tagActive">请输入验证码</span>
                <el-button
                  type="primary"
                  @click="getMessageCaptcha()"
                  v-if="captchaType == false"
                  :disabled="
                    /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(
                      mobile
                    ) == false
                  "
                  :loading="greyLoad"
                  >获取验证码</el-button
                >
                <!-- <el-button v-if="captchaType == true" disabled>{{ timeNum }}秒后重发</el-button> -->
                <el-button type="primary" v-if="captchaType == true" disabled
                  >{{ timeNum }}秒后重发</el-button
                >
              </el-form-item>
              <p
                v-if="unRegisteredType"
                style="color: #ff4444; margin-bottom: 15px; font-size: 14px"
              >
                手机号未注册，请先注册后登录
              </p>
              <el-form-item>
                <el-button
                  type="primary"
                  @click="submitForm()"
                  :loading="loading"
                  >登录</el-button
                >
              </el-form-item>
              <!-- <div class="code-login">
								<span
									@click="
										() => {
											tagActive = 3 - tagActive
											unRegisteredType = false
										}
									"
								>
									{{ tagActive == 1 ? '验证码登录' : '密码登录' }}
								</span>
							</div> -->
            </el-form>
          </div>
        </div>
      </div>
      <!-- 扫码登录 -->
      <CodeLogin v-if="codeType == 2" @cloesAll="close"></CodeLogin>
    </div>
        <!--新增提示弹窗-->
    <div class="new_special" v-show="new_special">
      <img class="close_new" @click="handClicksubmit()" src="https://img.yilieyun.com/oss/ylyofficialWebImagse/icon_Close-2@2x.png"/>
      <div class="new_titlebox">
         <img src="https://yilie.oss-cn-beijing.aliyuncs.com/ats-speed-version/paginationImages/icon_modify%20successfully%402x.png"/>
         <span>申请完成</span>
      </div>
      <p class="new_text">账号申请已提交，系统审核完成后会将账号信息通过短信形式发送，请耐心等待！</p>
      <span class="new_submit" @click="handClicksubmit()">确定</span>
    </div>
    <div v-show="new_special" class="mask"></div>
  </div>
</template>
<script>
import { boo } from "../../../tool/apiboo.js";
import CodeLogin from "./code.vue";
export default {
  name: "LoginIndex",
  components: {
    CodeLogin,
  },
  data() {
    return {
      codeType: 1,
      tagActive: 1,
      mobile: "",
      password: "",
      setMessagCode: "",
      loading: false, //登录-按钮状态
      greyLoad: false, //获取短信验证码-按钮状态
      timeCountNext: 0, //60s短信倒计时-定时器
      captchaType: false, //倒计时-显示标示
      timeNum: 59, //60s短信倒计时-数字显示
      unRegisteredType: false, //手机号注册状态
      eyeType: true,
      usermsg: "",
      new_special:false,
      have_mobile:false,
      have_password:false,
      have_tagActive:false,
      have_mobile_text:'请输入手机号',
    };
  },
  methods: {
    handClicksubmit(){
      this.new_special=false;
      this.close();
    },
    verify() {
      if (!this.mobile) {
        return { msg: "请输入手机号", result: false };
      }
      if (this.tagActive == 1 && !this.password) {
        return { msg: "请输入密码", result: false };
      }
      if (this.tagActive == 2 && !this.setMessagCode) {
        return { msg: "请输入验证码", result: false };
      }
      return { result: true };
    },
    getfocusPassword() {
      if(!this.mobile){//手机号校验
          this.have_mobile=true;
          return;
        }else{
          this.have_mobile=false;
        }

        const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if(!reg.test(this.mobile)){
              this.have_mobile_text='请输入11位手机号'
              this.have_mobile=true;
              return;
        }else{
              this.have_mobile=false;
        }
      this.unRegisteredType = false;
      this.have_password = false;
    },
    getfocustagActive() {
      if(!this.mobile){//手机号校验
          this.have_mobile=true;
          return;
        }else{
          this.have_mobile=false;
        }

        const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if(!reg.test(this.mobile)){
              this.have_mobile_text='请输入11位手机号'
              this.have_mobile=true;
              return;
        }else{
              this.have_mobile=false;
        }
        this.unRegisteredType = false;
        this.setMessagCode = false;
    },
    getCaptcha() {
      return new Promise((resolve) => {
        const appid = "2042127609";
        let captcha = new TencentCaptcha(
          appid,
          function (res) {
            if (res.ret === 0) {
              resolve({
                randstr: res.randstr,
                ticket: res.ticket,
              });
            }
          },
          { needFeedBack: false }
        );
        captcha.show();
      });
    },

    async submitForm() {
      try {
        // 执行验证
        // const ret = this.verify();

        // if (!ret.result) {
        //   return this.$message({
        //     message: ret.msg,
        //     type: "error",
        //     center: true,
        //     duration:1000000000,
        //     customClass: "loginCustomClass",
        //   });
        // }
        if(!this.mobile){//手机号校验
          this.have_mobile=true;
          return;
        }else{
          this.have_mobile=false;
        }

        const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
        if(!reg.test(this.mobile)){
              this.have_mobile_text='请输入11位手机号'
              this.have_mobile=true;
              return;
        }else{
              this.have_mobile=false;
        }

        if (this.tagActive == 1 && !this.password) {
          this.have_password=true;
          this.have_password_text='请输入密码'
          return;
        }else{
          this.have_password=false;
        }
         if (this.tagActive == 2 && !this.setMessagCode) {
          this.have_tagActive=true
          return;
        }else{
          this.have_tagActive=false;
        }

        let getUserInfo;
        if (this.tagActive == 1) {
          var random = this.randomWord(50, 50);
          localStorage.removeItem("ClientBrowseIds");
          localStorage.setItem("ClientBrowseIds", random);
          // 账号密码登录
          const geSture = await this.getCaptcha(); // 验证码流程
          // 执行登录
          this.loading = true;
          getUserInfo = await this.pwdLoginApi({
            mobile: this.mobile,
            password: this.password,
            randstr: geSture.randstr,
            ticket: geSture.ticket,
            clientBrowseId: random,
          });
          this.usermsg = getUserInfo;
        } else {
           var random = this.randomWord(50, 50);
          localStorage.removeItem("ClientBrowseIds");
          localStorage.setItem("ClientBrowseIds", random);
          // 短信验证码登录
          getUserInfo = await this.codeLoginApi({
            mobile: this.mobile,
            code: this.setMessagCode,
            clientBrowseId: random,
          });

          if (getUserInfo.data.msg == "手机号未注册") {
            this.unRegisteredType = true;
            return;
          }
          if (getUserInfo.data.msg == "销售顾问将于1个工作日内联系您,同步账号密码信息，请耐心等待!") {
            //弹框提示
            this.new_special=true;
            return;
          }
          this.usermsg = getUserInfo;
        }

        // 身份信息注入，跳转极速版首页
        const userinfo = getUserInfo.data.data;
        var cbid= localStorage.getItem("ClientBrowseIds", "");
        console.log(userinfo,"用户信息");
        console.log(cbid,"登录id");
        localStorage.setItem('name',userinfo.profile.name);
        localStorage.setItem('versionsStatus',userinfo.profile.versionsStatus);
        localStorage.setItem('access_token',userinfo.access_token);
        localStorage.setItem('playedu_token',userinfo.playedu_token);
        localStorage.setItem('domanUrl',userinfo.profile.domain);
        localStorage.setItem('userinfo',JSON.stringify(userinfo));
        userinfo.ClientBrowseId=cbid;
        console.log("https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(userinfo),"跳转地址");
        const domanUrl = userinfo.profile.domain;
        // console.log("https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(userinfo))
        // alert("https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(userinfo))
        let learntype=localStorage.getItem('learntype');
        let learncourse_url=localStorage.getItem('learncourse_url');
        let url=localStorage.getItem('url');
        let {playedu_token, ...newObj} = userinfo;
        if(learntype=='1'){
          let url=`${url}login?token=${userinfo.playedu_token}&url=${learncourse_url}/&userinfo=${JSON.stringify(newObj)}`;
               console.log(url);
               window.open(url)
        }else{
          // window.open(
          //   "https://" + domanUrl + "#/jump/?userinfo=" + JSON.stringify(newObj)
          // );
        }
        

        //隐藏弹框
        this.close();
      } catch (err) {
        this.loading = false;
        let bo = err.includes("Network");
        return this.$message({
          message: bo ? "验证码服务加载失败，请刷新后重试" : err,
          type: "error",
          center: true,
          customClass: "loginCustomClass",
        });
      }
      if (this.tagActive == 1) {
        //密码登录
        console.log(this.usermsg.data.data.profile.tenantName);
        zhuge.track("登录", {
          租户: this.usermsg.data.data.profile.tenantName,
          分类: "密码登录",
          入口: "官网",
          客户类型: this.usermsg.data.data.profile.clientClassify,
        });
      } else {
        //验证码登录
        console.log(this.usermsg.data.data.profile.tenantName);
        zhuge.track("登录", {
          租户: this.usermsg.data.data.profile.tenantName,
          分类: "验证码登录",
          入口: "官网",
          客户类型: this.usermsg.data.data.profile.clientClassify,
        });
      }
    },
    // 账号密码-登录接口
    pwdLoginApi(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/login`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response);
            } else {
              reject(response.data.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 短信验证码-登录接口
    codeLoginApi(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/smsVerificationCodeLogin`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response);
            }else {
              if (response.data.msg == "手机号未注册") {
                resolve(response);
              }else if(response.data.msg == "销售顾问将于1个工作日内联系您,同步账号密码信息，请耐心等待!"){
                resolve(response);
              } else {
                reject(response.data.msg);
              }
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    // 随机生成字母数字组成的字符
    randomWord(min, max) {
      var returnStr = "",
        range = max ? Math.round(Math.random() * (max - min)) + min : min,
        charStr =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

      for (var i = 0; i < range; i++) {
        var index = Math.round(Math.random() * (charStr.length - 1));
        returnStr += charStr.substring(index, index + 1);
      }
      return returnStr;
    },
    // 获取短信验证码
    async getMessageCaptcha() {
      try {
        this.greyLoad = true;
        let res = await this.sendSmsVerifyCode({
          type: 2,
          phone: this.mobile,
        });
        console.log(res.data);
        this.greyLoad = false;
        this.captchaType = true;
        //短信验证码-60s倒计时开始
        this.timeCountNext = window.setInterval(() => {
          if (this.timeNum > 0) {
            this.timeNum -= 1;
          } else {
            window.clearInterval(this.timeCountNext);
            this.timeCountNext = 0;
            this.captchaType = false;
            this.timeNum = 59;
          }
        }, 1000);
      } catch (err) {
        this.greyLoad = false;
        let bo = err.includes("Network");
        return this.$message({
          message: bo ? "验证码服务加载失败，请刷新后重试" : err,
          type: "error",
          center: true,
          customClass: "loginCustomClass",
        });
      }
    },
    // 短信验证码接口
    sendSmsVerifyCode(data) {
      return new Promise((resolve, reject) => {
        const url = `https://officialsiteapi${boo()}.yilieyun.com/siteapi/Apply/sendTransferNote`;
        let params = new FormData();
        for (const key of Object.keys(data)) {
          params.append(key, data[key]);
        }
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        this.$axios
          .post(url, params, config)
          .then((response) => {
            if (response.data.code == 200) {
              resolve(response);
            } else {
              reject(response.data.msg);
            }
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    close() {
      // 隐藏
      this.$eventBus.$emit("loginModel", false);
    },
  },
};
</script>
<style lang="less" scoped>
.main {
  width: 100%;
  display: flex;
  justify-content: center;
  .model-main {
    width: 1490px;
    position: relative;
    display: flex;
    justify-content: flex-end;
  }
  .close {
    width: 458px;
    height: 40px;
    position: fixed;
    top: 120px;
    // left: 1595px;
    // transform: translate(1155px);
    // margin-right: 12px;
    display: flex;
    justify-content: space-between;
    z-index: 99999;
    // cursor: pointer;
  }
  .form-wrap {
    position: fixed;
    top: 105px;
    // left: 1180px;
    // transform: translate(745px);
    z-index: 9999;
    width: 458px;
    height: 438px;
    background: #ffffff;
    box-shadow: 0px 2px 16px 0px #a5c6ed;
    user-select: none;
    // margin-right: 10%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 32px 60px 50px;
    border-radius: 8px;
    h2 {
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #5666ff;
      font-size: 40px;
      margin: 0 0 35px 0;
    }
    .form {
      background-color: #ffffff;
      border-radius: 2px;
      .title {
        font-size: 30px;
        color: #333333;
        padding: 32px 40px;
        margin: 0;
        text-align: center;
      }

      .content {
        // height: 310px;
        margin: 15px 0 0;
        display: flex;
        justify-content: center;
        .el-form {
          width: 100%;
          .verifiCation {
            .el-input {
              width: 58%;
            }

            .el-button {
              width: 40%;
              margin: 0;
            }
          }
          .code-login {
            display: flex;
            justify-content: flex-end;
            span {
              font-size: 16px;
              cursor: pointer;
              color: #5666ff;
            }
          }
        }
        .eye {
          cursor: pointer;
          position: absolute;
          top: 20px;
          right: 10px;
          img {
            width: 20px;
          }
        }
      }
    }
  }
}
.new_special{
  position: fixed !important;
  top: calc(50vh - 65px);
  left: calc(50% - 240px);
  width: 502px !important;
  min-height: 246px !important;
  height: max-content;
  background: #ffffff;
  border-radius: 4px;
  z-index: 9999;
  position: relative;
  padding-left: 110px;
  padding-right: 110px;
  box-sizing: border-box;
  box-shadow: 0px 0px 15px 0px rgba(41,53,57,0.32);
  .close_new{
    position: absolute;
    width: 29px;
    height: 29px;
    right: 20px;
    top: 10px;
    cursor: pointer;
  }
  .new_titlebox{
    width: 100%;
    height: 30px;
    margin-top: 22px;
    img{
      display: inline-block;
      width: 40px;
      height: 40px;
      vertical-align: middle;
      margin-left: 77px;
    }
    span{
      font-size: 20px;
      color: #666666;
      vertical-align: middle;
    }
  }
  .new_text{
    display: inline-block;
    text-align: center;
    font-size: 18px;
    color: #1d2754;
    margin-top: 30px;
    line-height: 28px;
  }
  .new_submit{
    display: inline-block;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 160px;
    width: 134px;
    height: 48px;
    background: #0084ff;
    border-radius: 10px;
    border: none;
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    line-height: 48px;
    cursor: pointer;
  }
}
.tips_red{
  position: absolute;
  display: block;
  width: 300px;
  height: 30px;
  line-height: 30px;
  left: 10px;
  color: #f56c6c;
}
</style>
<style lang="less">
.form-wrap {
  .form {
    .el-input__inner {
      height: 54px;
      font-size: 18px;
    }

    .el-button--primary {
      height: 54px;
      width: 100%;
      background: #5666ff;
      font-size: 16px;
    }
  }
}

.loginCustomClass {
  top: 355px !important;
  height: 60px !important;
  background: #36425e !important;
  font-size: 18px !important;
  color: #ffffff !important;
  opacity: 0.83 !important;
  border: none !important;
  border-radius: 13px !important;
  transform: translate(183px);
  z-index: 999999 !important;
  i {
    display: none;
  }

  p {
    color: #fff !important;
    font-size: 20px;
  }
}
.el-form-item{
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/views/login/index.vue